import { Outlet } from "react-router";
import {
  User,
  Bell,
  Eye,
  Settings,
  Shield,
} from "lucide-react";
import { SidebarProvider, SidebarInset } from "@kubdee/ui/shadcn/sidebar";
import { AppSidebar, type NavGroup } from "@kubdee/ui/shell/app-sidebar";

const meNav: NavGroup[] = [
  {
    label: "ของฉัน",
    items: [
      { title: "โปรไฟล์", href: "/me", icon: User, exact: true },
      { title: "การแจ้งเตือน", href: "/me/notifications", icon: Bell },
      { title: "กำลังติดตาม", href: "/me/following", icon: Eye },
    ],
  },
  {
    label: "ตั้งค่า",
    items: [
      { title: "การแจ้งเตือน", href: "/me/preferences", icon: Settings },
      { title: "ความปลอดภัย", href: "/me/security", icon: Shield },
    ],
  },
];

export default function MeLayout({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <SidebarProvider>
      <AppSidebar
        title="ของฉัน"
        icon={User}
        color="#6b7280"
        navGroups={meNav}
      />
      <SidebarInset className="flex flex-col h-svh min-w-0 overflow-hidden">
        {children ?? <Outlet />}
      </SidebarInset>
    </SidebarProvider>
  );
}
